<!-- 登记服务人员管理 -->
<template>
  <div class="container">
    <div class="vue">
      <div class="header flex">
        <div class="head-title borderB">
          <div class="text">登记服务人员</div>
        </div>
        <div class="headSearch Fs14">
          <div class="form-data group">
            <span>状态：</span>
            <el-select
              size="mini"
              v-model="selectedOptions"
              @change="cascaderChange"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <!-- <el-button @click="addStatusBut" round type="primary" size="small"
          >添加服务人员</el-button
        > -->
      </div>
      <div class="content">
        <el-table
          :header-cell-style="{ background: '#f5f5f5' }"
          :data="ServiceList.list"
          style="width: 100%"
        >
          <el-table-column prop="id" label="#"> </el-table-column>
          <el-table-column prop="name" label="姓名"> </el-table-column>
          <el-table-column prop="tel" label="手机号"> </el-table-column>
          <el-table-column label="性别">
            <template slot-scope="scope">
              {{ scope.row.sex | filterNum('男', '女') }}
            </template>
          </el-table-column>
          <el-table-column prop="health" label="健康"> </el-table-column>
          <el-table-column label="是否有证书">
            <template slot-scope="scope">
              {{ scope.row.iscertificate | filterNum('无', '有') }}
            </template>
          </el-table-column>
          <el-table-column label="证书图片" class="certificateImg">
            <template slot-scope="scope">
              <el-image
                v-if="scope.row.certificateimg === ''"
                style="width: 100px; height: 100px"
                :src="scope.row.certificateimg"
              >
              </el-image>
              <el-image
                v-else
                style="width: 100px; height: 100px"
                :src="scope.row.certificateimg"
                :preview-src-list="[scope.row.certificateimg]"
              >
              </el-image>
              <!-- <img
                :src="scope.row.certificateimg"
                alt=""
                class="certificateImg"
              /> -->
            </template>
          </el-table-column>
          <el-table-column prop="workyears" label="工作年限"> </el-table-column>
          <el-table-column prop="address" label="地址"> </el-table-column>
          <el-table-column prop="canworkingtime" label="工作时间">
          </el-table-column>

          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-popconfirm
                v-if="scope.row.isread === 0"
                @confirm="auditBut(scope.row)"
                title="确定信息无误，进行审核通过操作吗？"
              >
                <el-link slot="reference" :underline="false" type="primary"
                  >审核</el-link
                >
              </el-popconfirm>
              <span v-else>---</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="Pagination flex">
          <div class="text">
            <span>共{{ ServiceList.total }}条记录，</span>
            <span class="pageNum">{{ ServiceList.pageNum }}</span>
            <span>/{{ ServiceList.pages }}页</span>
          </div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="ServiceList.pageNum"
            :page-size="ServiceList.pageSize"
            layout="prev, pager, next, jumper"
            :total="ServiceList.total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiGetServerInsertList, apiIsRead } from '@/api/management'

export default {
  name: '',
  props: [''],
  data() {
    return {
      ServiceList: [], // 列表
      pages: {
        page: 1,
        size: 20
      }, // 页数
      options: [
        { label: '待审核', value: 0 },
        { label: '已审核', value: 1 }
      ],
      selectedOptions: 0,
      dialogAdmin: false,
      dialogTitle: '',
      isEdit: false, // 判断是否为修改管理员
      adId: '', // 管理员id
      UserForm: {
        tel: '',
        password: '',
        servername: '',
        serviceSpecialize: '',
        image: '',
        server: '',
        anworktime: ''
      },
      adminFormEmail: '',
      adminFormList: ['姓名不能为空！', '手机账号不能为空！', '密码不能为空！']
    }
  },

  components: {},

  computed: {},

  beforeMount() {},

  mounted() {
    this.GetServiceList()
  },

  methods: {
    // 状态切换
    cascaderChange() {
      this.pages.page = 1
      console.log(this.selectedOptions)
      this.GetServiceList()
    },
    // 审核
    auditBut(row) {
      apiIsRead({
        id: row.id
      }).then(res => {
        if (res.status === 0) {
          this.$Ms(res.msg)
          this.GetServiceList()
        } else if (res.status === 1) {
          this.$Me(res.msg)
        }
      })
    },
    // 分页
    handleCurrentChange(val) {
      this.pages.page = val
      console.log(`当前页: ${val}`)
      this.GetServiceList()
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
    },
    // 接口
    // 获取登记服务人员列表
    GetServiceList() {
      apiGetServerInsertList({
        page: this.pages.page,
        pageSize: this.pages.size,
        isRead: this.selectedOptions
      }).then(res => {
        if (res.status === 0) {
          this.ServiceList = res.data
        }
      })
    }
  },

  watch: {}
}
</script>
<style lang="scss" scoped>
.flex {
  display: flex;
}
.FZ0875 {
  font-size: 0.875em;
}
.textalignLeft {
  text-align: left;
}
.vue {
  background-color: #fff;
  border-left: 2px solid #119685;
  .header {
    justify-content: space-between;
    .text {
      text-align: left;
      // font-size: 0.875em;
      color: #119685;
      padding: 10px 5px;
    }
    .el-button {
      margin: 10px;
    }
  }
  .content {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: calc(100vh - 172px);
    .el-table {
      height: calc(100vh - 224px);
      overflow: auto;
    }
    /deep/ .el-table .warning-row {
      background: oldlace;
    }

    /deep/ .el-table .success-row {
      background: #f0f9eb;
    }
    .el-table {
      /deep/ .certificateImg {
        width: 100%;
        height: 50px;
      }
    }
    .Pagination {
      justify-content: space-between;
      padding: 10px 20px;
      align-items: center;
      font-size: 0.875em;
      color: #7b7b7b;
      .text {
        .pageNum {
          color: #119685;
        }
      }
    }
  }
}
.dialog {
}
</style>
